import { getEnvironment } from '@gonfalon/openapi/operations/getEnvironment';
import { getEnvironments } from '@gonfalon/openapi/operations/getEnvironments';
import { getEnvironmentsByProject } from '@gonfalon/openapi/operations/getEnvironmentsByProject';
import { getEnvironmentSummaries } from '@gonfalon/openapi/operations/getEnvironmentSummaries';
import type { schemas } from '@gonfalon/openapi/types';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createInfiniteQueryOptions } from '../internal/createInfiniteQueryOptions';
import { createQueryOptions } from '../internal/createQueryOptions';

export type EnvironmentListingRep = schemas['EnvironmentListingRep'];
export type EnvironmentsByProject = schemas['Environments'];
export const environmentSummariesQuery = createQueryOptions(getEnvironmentSummaries);
export const getEnvironmentQuery = createQueryOptions(getEnvironment);
export const getEnvironmentsQuery = createQueryOptions(getEnvironments);
export const getInfiniteEnvironmentsByProjectQuery = createInfiniteQueryOptions(getEnvironmentsByProject);
export const getEnvironmentsByProjectQuery = createQueryOptions(getEnvironmentsByProject);

/**
 * Invalidate every cached environments-by-project list for a project.
 *
 * The plain and infinite factories above get distinct query ids, so a key built from one never
 * matches the other. Environment mutations must call this rather than invalidating one of them, or
 * screens on the other list (the settings routes drain the infinite one) keep showing stale data.
 */
export async function invalidateEnvironmentsByProject(projectKey: string) {
  const queryClient = getQueryClient();
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: getEnvironmentsByProjectQuery.partialQueryKey({ projectKey }) }),
    queryClient.invalidateQueries({ queryKey: getInfiniteEnvironmentsByProjectQuery.partialQueryKey({ projectKey }) }),
  ]);
}
